// Build424: editable attached arrow labels; NFC supplies defaults, not a visibility lock.
// Build414: coordinated multi-selection; historical predecessor retained.
// Build405: Italian editor localization; historical predecessor retained.
// Build 20260913-357: index order fields per save and skip unchanged values.
// Build 20260909-324: axis preferences and canonical keyboard movement.
(() => {
  const style = document.createElement('style');
  style.dataset.smoofArrowEditorStyles = 'v2-19';
  style.textContent = String.raw`
  [data-smoof-arrow-graphic] {
    transition:
      filter 0.15s ease,
      opacity 0.15s ease;
  }

  [data-smoof-arrow-graphic][data-active="true"] {
    filter:
      drop-shadow(0 0 1px #fff)
      drop-shadow(0 0 3px #19a7ff);
  }

  [data-smoof-arrow-selection-frame] {
    position: absolute;
    box-sizing: border-box;
    border: 1.5px dashed #19a7ff;
    border-radius: 6px;
    background: rgba(25, 167, 255, 0.04);
    box-shadow:
      0 0 0 1px rgba(255, 255, 255, 0.72);
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition:
      opacity 0.15s ease,
      visibility 0.15s ease;
  }

  [data-smoof-arrow-snap-guide] {
    position: absolute;
    z-index: 100;
    display: none;
    pointer-events: none;
    background: #19a7ff;
    box-shadow: 0 0 0 0.5px rgba(255, 255, 255, 0.8);
  }

  [data-smoof-arrow-snap-guide="x"] {
    top: 0;
    bottom: 0;
    width: 1px;
  }

  [data-smoof-arrow-snap-guide="y"] {
    left: 0;
    right: 0;
    height: 1px;
  }

  [data-smoof-arrow-overlay][data-active="true"]
    [data-smoof-arrow-selection-frame] {
    opacity: 1;
    visibility: visible;
  }

  [data-smoof-arrow-controls] {
    position: absolute;
    left: 84.5%;
    top: 47.3%;
    z-index: 2;
    transform: translate(-50%, -50%);

    width: 82px;
    min-height: 52px;
    padding: 5px 6px;
    box-sizing: border-box;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;

    border-radius: 28px;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition:
      opacity 0.15s ease,
      visibility 0.15s ease;
  }

  /* Ohne NFC besteht die Werkzeugleiste nur aus der Pfeilfarbe. */
  [data-smoof-arrow-controls][data-smoof-nfc-labels-visible="false"] {
    width: 48px;
  }

  [data-smoof-arrow-overlay][data-active="true"]
    [data-smoof-arrow-controls] {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }

  [data-smoof-arrow-color-input] {
    width: 27px;
    height: 27px;
    padding: 0;
    border: 1px solid #222;
    border-radius: 50%;
    background: transparent;
    overflow: hidden;
    cursor: pointer;
    touch-action: manipulation;
  }

  [data-smoof-arrow-color-input]::-webkit-color-swatch-wrapper {
    padding: 0;
  }

  [data-smoof-arrow-color-input]::-webkit-color-swatch {
    border: 0;
    border-radius: 50%;
  }

  [data-smoof-arrow-color-input]::-moz-color-swatch {
    border: 0;
    border-radius: 50%;
  }

  [data-smoof-arrow-label-color-input] {
    width: 27px;
    height: 27px;
    padding: 0;
    border: 1px solid #222;
    border-radius: 50%;
    background: transparent;
    overflow: hidden;
    cursor: pointer;
    touch-action: manipulation;
  }

  [data-smoof-arrow-label-color-input]::-webkit-color-swatch-wrapper {
    padding: 0;
  }

  [data-smoof-arrow-label-color-input]::-webkit-color-swatch {
    border: 0;
    border-radius: 50%;
  }

  [data-smoof-arrow-label-color-input]::-moz-color-swatch {
    border: 0;
    border-radius: 50%;
  }

  [data-smoof-arrow-color-group] {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1px;
    color: #111;
    font-family: Arial, sans-serif;
    font-size: 9px;
    font-weight: 700;
    line-height: 1;
    cursor: pointer;
  }

  @media (max-width: 749px) {
    [data-smoof-arrow-controls] {
      position: fixed;
      left: 50%;
      right: auto;
      top: auto;
      bottom:
        calc(
          14px +
          env(safe-area-inset-bottom, 0px)
        );
      z-index: 2147483600;
      transform: translateX(-50%);

      width: 126px;
      min-height: 70px;
      padding: 6px 8px;
      gap: 10px;

      border: 1px solid rgba(0, 0, 0, 0.18);
      border-radius: 38px;
      box-shadow:
        0 6px 24px rgba(0, 0, 0, 0.24);

      pointer-events: auto !important;
      touch-action: manipulation;
      isolation: isolate;
    }

    [data-smoof-arrow-controls][data-smoof-nfc-labels-visible="false"] {
      width: 70px;
    }

    [data-smoof-arrow-color-input] {
      width: 48px;
      height: 48px;
    }

    [data-smoof-arrow-label-color-input] {
      width: 48px;
      height: 48px;
    }

    [data-smoof-arrow-color-group] {
      gap: 2px;
      font-size: 10px;
    }

    [data-smoof-arrow-selection-frame] {
      border-width: 2px;
      border-radius: 8px;
    }
  }
`;
  document.head.appendChild(style);
})();

(() => {
  if (window.__smoofArrowEditorV23Build324) return;
  window.__smoofArrowEditorV23Build324 = true;
  window.__smoofArrowEditorV23 = true;
  document.documentElement.dataset.smoofArrowRuntime = 'v2.25-keyboard-20260909-324';

  const OPTION_SELECTOR =
    '[data-option-id="331a45ae-bd3d-4b85-8c7f-a8cbf014b032"]';

  const LABEL_OPTION_SELECTOR =
    '[data-option-id="1f69ffa6-f179-46de-8ee6-5a90ac70558f"]';

  const LEFT_URL =
    'https://cdn.shopify.com/s/files/1/0996/4136/0721/files/Left.svg?v=1785255586';

  const RIGHT_URL =
    'https://cdn.shopify.com/s/files/1/0996/4136/0721/files/Right.svg?v=1785255586';

  let overlay = null;
  let nativeEraserOverlay = null;
  let arrowColorControl = null;
  let guideX = null;
  let guideY = null;
  let currentStage = null;
  let renderPending = false;
  let arrowsSelected = false;
  let activeArrowSide = 'left';
  let activeArrowDrag = null;
  let arrowStateHydrated = false;
  let nativeArrowNodesHidden = 0;

  const ARROW_SIZE = {
    width: 0.1456,
    height: 0.0827
  };
  const PICTOGRAM_SIZE = {
    height: 0.064,
    withLabelHeight: 0.087
  };
  /* Exakte sichtbare Pfeilhöhe aus dem SVG: y 0 bis 31,42 bei 48,27. */
  const ARROW_ONLY_HEIGHT_FACTOR = 31.42 / 48.27;
  /* Verhindert einen Antialiasing-Rest des nächsten Pfeilelements. */
  const ARROW_CROP_GAP = 0.006;
  const SNAP_THRESHOLD = 0.012;

  /*
   * Easify zeichnet die beiden ursprünglichen Pfeil-SVGs zusätzlich in
   * seinen Konva-Canvas. Unsere bearbeitbare DOM-Version liegt darüber.
   * Bleibt das Canvas-Original sichtbar, verdeckt es optisch Änderungen an
   * Drehung und Pfeilanzahl. Deshalb werden ausschließlich die beiden
   * bekannten Originaldateien im Konva-Layer ausgeblendet.
   */
  function nativeArrowNodeSource(node) {
    const attrs = node?.attrs || {};
    let image = attrs.image;

    try {
      if (typeof node?.image === 'function') image = node.image() || image;
    } catch (error) {
      /* Ein unvollständig initialisierter Konva-Knoten wird später erneut geprüft. */
    }

    const primitiveAttrs = Object.entries(attrs)
      .filter(([, value]) => (
        typeof value === 'string' ||
        typeof value === 'number'
      ))
      .map(([key, value]) => `${key}:${value}`);

    return [
      image?.currentSrc,
      image?.src,
      ...primitiveAttrs
    ]
      .filter(Boolean)
      .join(' ');
  }

  function isNativeArrowNode(node) {
    const source = nativeArrowNodeSource(node);

    return (
      /(?:\/|%2f)(?:Left|Right)\.svg(?:[?&#]|$)/i.test(source) ||
      /1785255586/.test(source)
    );
  }

  function suppressNativeArrowNodes(marker) {
    const stages = Array.from(
      window.Konva?.stages ||
      window.konva?.stages ||
      []
    );

    let hidden = 0;

    stages.forEach(stage => {
      if (typeof stage?.find !== 'function') return;

      let stageChanged = false;

      try {
        stage.find('Image').forEach(node => {
          if (!isNativeArrowNode(node)) return;

          if (typeof node.visible === 'function' && node.visible()) {
            node.visible(false);
            stageChanged = true;
          }

          node.setAttr?.('smoofNativeArrowHidden', true);
          hidden += 1;
        });
      } catch (error) {
        /* Der Canvas kann während eines Variantenwechsels kurz neu aufgebaut werden. */
      }

      if (stageChanged) stage.batchDraw?.();
    });

    nativeArrowNodesHidden = hidden;

    if (marker) {
      marker.dataset.smoofNativeArrowNodes = String(hidden);
      marker.dataset.smoofNativeArrowLayer = hidden > 0
        ? 'suppressed'
        : 'not-found';
    }

    return hidden;
  }

  function arrowVisualWidth(state) {
    const scale = pictogramScale(state);
    if (state.symbol && state.symbol !== 'dots') {
      return PICTOGRAM_SIZE.height * pictogramAspect(state) * scale;
    }
    const fraction = state.count >= 4
      ? 1
      : Math.max(0.1, state.count / 4 - ARROW_CROP_GAP);
    return ARROW_SIZE.width * fraction * scale;
  }

  function arrowVisualMetrics(side, state) {
    const width = arrowVisualWidth(state);
    const fullWidth = pictogramIsStandard(state)
      ? ARROW_SIZE.width * pictogramScale(state)
      : PICTOGRAM_SIZE.height * pictogramAspect(state) * pictogramScale(state);
    return {
      width,
      offsetX: state.symbol && state.symbol !== 'dots'
        ? 0
        : (side === 'left' ? fullWidth - width : 0)
    };
  }

  function pictogramIsStandard(state) {
    return !state.symbol || state.symbol === 'dots';
  }

  function pictogramAspect(state) {
    if (pictogramIsStandard(state)) return ARROW_SIZE.width / (ARROW_SIZE.height * ARROW_ONLY_HEIGHT_FACTOR);
    const icon = window.SmoofPictogramLibrary?.get?.(state.symbol);
    return clamp(Number(icon?.aspect) || 1, 0.18, 8);
  }

  function pictogramScale(state) {
    return clamp(Number(state?.scale) || 1, 0.1, 8);
  }

  function pictogramGraphicHeight(state) {
    const height = pictogramIsStandard(state)
      ? ARROW_SIZE.height * ARROW_ONLY_HEIGHT_FACTOR
      : PICTOGRAM_SIZE.height;
    return height * pictogramScale(state);
  }

  function pictogramVisualHeight(state, labelVisible) {
    if (pictogramIsStandard(state)) {
      return ARROW_SIZE.height * (labelVisible ? 1 : ARROW_ONLY_HEIGHT_FACTOR) * pictogramScale(state);
    }
    return PICTOGRAM_SIZE.height * pictogramScale(state);
  }

  const ARROW_DEFAULTS = {
    left: {
      x: 0.1898,
      y: 0.4731,
      rotation: 0,
      count: 4,
      scale: 1,
      symbol: 'dots',
      customSvg: '',
      customName: '',
      colorize: false,
      visible: true,
      labelVisible: true,
      label: window.SmoofArrowLabels.defaults(),
      arrowColor: '#000000',
      labelColor: '#000000'
    },
    right: {
      x: 0.6646,
      y: 0.4731,
      rotation: 0,
      count: 4,
      scale: 1,
      symbol: 'dots',
      customSvg: '',
      customName: '',
      colorize: false,
      visible: true,
      labelVisible: true,
      label: window.SmoofArrowLabels.defaults(),
      arrowColor: '#000000',
      labelColor: '#000000'
    }
  };

  const NATIVE_ERASER_BOUNDS = {
    left: {
      left: 0.12,
      right: 0.36,
      top: 0.44,
      bottom: 0.58
    },
    right: {
      left: 0.64,
      right: 0.88,
      top: 0.44,
      bottom: 0.58
    }
  };

  function nativeArrowEraserClip(side) {
    const bounds = NATIVE_ERASER_BOUNDS[side];
    const left = bounds.left * 100;
    const top = bounds.top * 100;
    const right = bounds.right * 100;
    const bottom = bounds.bottom * 100;

    return `polygon(${left}% ${top}%, ${right}% ${top}%, ${right}% ${bottom}%, ${left}% ${bottom}%)`;
  }

  function createNativeArrowEraser(side) {
    const eraser = document.createElement('div');
    const clip = nativeArrowEraserClip(side);

    eraser.dataset.smoofNativeArrowEraser = side;
    eraser.setAttribute('aria-hidden', 'true');

    Object.assign(eraser.style, {
      position: 'absolute',
      inset: '0',
      zIndex: '0',
      pointerEvents: 'none',
      clipPath: clip
    });

    eraser.style.setProperty('-webkit-clip-path', clip);

    return eraser;
  }

  function updateNativeArrowErasers() {
    if (!nativeEraserOverlay) return;

    const colorLayer = document.querySelector(
      '[data-smoof-background-color]'
    );

    const imageLayer = document.querySelector(
      '[data-smoof-background-image]'
    );

    const colorStyle = colorLayer
      ? getComputedStyle(colorLayer)
      : null;

    const imageStyle = imageLayer
      ? getComputedStyle(imageLayer)
      : null;

    const imageVisible = Boolean(
      imageStyle &&
      imageStyle.display !== 'none' &&
      imageStyle.backgroundImage !== 'none'
    );

    nativeEraserOverlay
      .querySelectorAll(
        '[data-smoof-native-arrow-eraser]'
      )
      .forEach(eraser => {
        eraser.style.backgroundColor =
          colorStyle?.backgroundColor ||
          '#ffffff';

        const gradientImage =
          colorStyle?.backgroundImage &&
          colorStyle.backgroundImage !== 'none'
            ? colorStyle.backgroundImage
            : '';

        eraser.style.backgroundImage = imageVisible
          ? [imageStyle.backgroundImage, gradientImage]
              .filter(Boolean)
              .join(', ')
          : (gradientImage || 'none');

        eraser.style.backgroundSize = imageVisible
          ? [imageStyle.backgroundSize, gradientImage ? '100% 100%' : '']
              .filter(Boolean)
              .join(', ')
          : (gradientImage ? '100% 100%' : 'auto');

        eraser.style.backgroundPosition = imageVisible
          ? [imageStyle.backgroundPosition, gradientImage ? '0% 0%' : '']
              .filter(Boolean)
              .join(', ')
          : '0% 0%';

        eraser.style.backgroundRepeat = imageVisible
          ? [imageStyle.backgroundRepeat, gradientImage ? 'no-repeat' : '']
              .filter(Boolean)
              .join(', ')
          : (gradientImage ? 'no-repeat' : 'repeat');
      });
  }

  const arrowState = {
    left: { ...ARROW_DEFAULTS.left },
    right: { ...ARROW_DEFAULTS.right }
  };

  const ARROW_PROPERTIES = {
    visible: 'properties[_SMOOF Pfeile sichtbar]',
    leftX: 'properties[_SMOOF Pfeile links X]',
    leftY: 'properties[_SMOOF Pfeile links Y]',
    rightX: 'properties[_SMOOF Pfeile rechts X]',
    rightY: 'properties[_SMOOF Pfeile rechts Y]',
    leftVisible: 'properties[_SMOOF Pfeilgruppe 1 sichtbar]',
    leftLabel: 'properties[_SMOOF Pfeil links Beschriftung JSON]',
    leftLabelVisible: 'properties[_SMOOF Pfeilgruppe 1 Text sichtbar]',
    leftRotation: 'properties[_SMOOF Pfeilgruppe 1 Drehung]',
    leftCount: 'properties[_SMOOF Pfeilgruppe 1 Anzahl]',
    leftScale: 'properties[_SMOOF Piktogramm links Skalierung]',
    leftSymbol: 'properties[_SMOOF Piktogramm links]',
    leftCustomSvg: 'properties[_SMOOF Piktogramm links SVG]',
    leftCustomName: 'properties[_SMOOF Piktogramm links Dateiname]',
    leftColorize: 'properties[_SMOOF Piktogramm links PNG einfarbig]',
    leftArrowColor: 'properties[_SMOOF Pfeilgruppe 1 Farbe]',
    leftLabelColor: 'properties[_SMOOF Pfeilgruppe 1 Textfarbe]',
    rightVisible: 'properties[_SMOOF Pfeilgruppe 2 sichtbar]',
    rightLabel: 'properties[_SMOOF Pfeil rechts Beschriftung JSON]',
    rightLabelVisible: 'properties[_SMOOF Pfeilgruppe 2 Text sichtbar]',
    rightRotation: 'properties[_SMOOF Pfeilgruppe 2 Drehung]',
    rightCount: 'properties[_SMOOF Pfeilgruppe 2 Anzahl]',
    rightScale: 'properties[_SMOOF Piktogramm rechts Skalierung]',
    rightSymbol: 'properties[_SMOOF Piktogramm rechts]',
    rightCustomSvg: 'properties[_SMOOF Piktogramm rechts SVG]',
    rightCustomName: 'properties[_SMOOF Piktogramm rechts Dateiname]',
    rightColorize: 'properties[_SMOOF Piktogramm rechts PNG einfarbig]',
    rightArrowColor: 'properties[_SMOOF Pfeilgruppe 2 Farbe]',
    rightLabelColor: 'properties[_SMOOF Pfeilgruppe 2 Textfarbe]'
  };

  /*
   * Die Produktionsdatei besitzt 2,5 mm Beschnitt. Die Interaktionsbox
   * enthält jedoch transparente/ungenutzte SVG-Fläche und bei den
   * Standardpfeilen zusätzlich den Beschriftungsbogen. Der größere
   * Bewegungsraum lässt deshalb die sichtbaren Pixel den realen
   * Produktionsbeschnitt erreichen; die Ausgabe selbst bleibt 2,5 mm.
   */
  const PICTOGRAM_PLACEMENT_ALLOWANCE_MM = 5;
  const EDITOR_SELECTION_EVENT =
    'smoof:editor-select';

  const VARIANT_CHANGE_EVENT =
    'smoof:shopify-variant-change';

  function clamp(value, minimum, maximum) {
    return Math.min(maximum, Math.max(minimum, value));
  }

  function pictogramConstraintRadius() {
    const spatial = window.SmoofSpatialConstraints;
    const trimRadius = Number(spatial?.printRadius) || 0.3534;
    const variant = window.SmoofProductVariant?.get?.() || {};
    const diameterMm = Math.max(1, Number(variant.diameterMm) || 80);
    const canonicalUnitsPerMm = (trimRadius * 2) / diameterMm;
    const policy = window.SmoofProductProfiles?.current?.editorPolicy;
    const laserEdgeMarginMm = Math.max(0, Number(policy?.laserEdgeMarginMm) || 0);

    if (laserEdgeMarginMm > 0 && variant.printProcess === 'laser') {
      return Math.max(0.01, trimRadius - laserEdgeMarginMm * canonicalUnitsPerMm);
    }

    return trimRadius + PICTOGRAM_PLACEMENT_ALLOWANCE_MM * canonicalUnitsPerMm;
  }

  function productForm() {
    return Array.from(document.querySelectorAll('form[action*="/cart/add"]'))
      .find(form => form.querySelector('button[type="submit"]')) || null;
  }

  function propertyInput(name) {
    return Array.from((productForm() || document).querySelectorAll('input'))
      .find(input => input.name === name) || null;
  }

  function setArrowProperty(name, value, form, inputs) {
    if (!form) return;
    let input = inputs.get(name);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
      inputs.set(name, input);
    }
    const nextValue = String(value);
    if (input.value !== nextValue) input.value = nextValue;
  }

  function syncLabels() {
    for (const side of ['left','right']) {
      const state=arrowState[side];state.label=window.SmoofArrowLabels.normalize(state.label);
      state.labelVisible=window.SmoofArrowLabels.resolve(state,side).visible;
    }
  }

  function loadArrowState() {
    const read = (name, fallback) => {
      const value = Number.parseFloat(propertyInput(name)?.value);
      return Number.isFinite(value) ? value : fallback;
    };
    const visible = propertyInput(ARROW_PROPERTIES.visible)?.value;
    const legacyVisible = visible === '' || visible == null
      ? true
      : !/^(0|false|no|nein)$/i.test(String(visible));
    const readBoolean = (name, fallback) => {
      const value = propertyInput(name)?.value;
      return value === '' || value == null
        ? fallback
        : !/^(0|false|no|nein)$/i.test(String(value));
    };
    const readColor = (name, fallback) => {
      const value = String(propertyInput(name)?.value || '');
      return /^#[0-9a-f]{6}$/i.test(value) ? value : fallback;
    };
    const readText = name => String(propertyInput(name)?.value || '');
    const readCustom = side => {
      const prefix = side === 'left' ? 'left' : 'right';
      const source = readText(ARROW_PROPERTIES[`${prefix}CustomSvg`]);
      const name = readText(ARROW_PROPERTIES[`${prefix}CustomName`]);
      const icon = source
        ? window.SmoofPictogramLibrary?.registerCustom?.(source, name)
        : null;
      return {
        customSvg: icon?.source || '',
        customName: icon ? name : '',
        customSymbol: icon?.id || ''
      };
    };
    const readSymbol = (name, customSymbol = '') => {
      const value = String(propertyInput(name)?.value || 'dots');
      if (customSymbol && (!value || value.startsWith('custom-'))) return customSymbol;
      return window.SmoofPictogramLibrary?.has?.(value) ? value : 'dots';
    };
    const leftCustom = readCustom('left');
    const rightCustom = readCustom('right');
    const optionArrowColor = document.querySelector(OPTION_SELECTOR)?.querySelector('input[type="color"]')?.value || '#000000';
    const optionLabelColor = document.querySelector(LABEL_OPTION_SELECTOR)?.querySelector('input[type="color"]')?.value || '#000000';
    arrowState.left = {
      ...ARROW_DEFAULTS.left,
      ...constrainArrowPosition('left', {
      x: read(ARROW_PROPERTIES.leftX, ARROW_DEFAULTS.left.x),
      y: read(ARROW_PROPERTIES.leftY, ARROW_DEFAULTS.left.y)
      }),
      visible: readBoolean(ARROW_PROPERTIES.leftVisible, legacyVisible),
      labelVisible: readBoolean(ARROW_PROPERTIES.leftLabelVisible, true),
      rotation: read(ARROW_PROPERTIES.leftRotation, 0),
      count: clamp(Math.round(read(ARROW_PROPERTIES.leftCount, 4)), 1, 4),
      scale: clamp(read(ARROW_PROPERTIES.leftScale, 1), 0.1, 8),
      symbol: readSymbol(ARROW_PROPERTIES.leftSymbol, leftCustom.customSymbol),
      customSvg: leftCustom.customSvg,
      customName: leftCustom.customName,
      colorize: readBoolean(ARROW_PROPERTIES.leftColorize, false),
      arrowColor: readColor(ARROW_PROPERTIES.leftArrowColor, optionArrowColor),
      labelColor: readColor(ARROW_PROPERTIES.leftLabelColor, optionLabelColor)
    };
    arrowState.right = {
      ...ARROW_DEFAULTS.right,
      ...constrainArrowPosition('right', {
      x: read(ARROW_PROPERTIES.rightX, ARROW_DEFAULTS.right.x),
      y: read(ARROW_PROPERTIES.rightY, ARROW_DEFAULTS.right.y)
      }),
      visible: readBoolean(ARROW_PROPERTIES.rightVisible, legacyVisible),
      labelVisible: readBoolean(ARROW_PROPERTIES.rightLabelVisible, true),
      rotation: read(ARROW_PROPERTIES.rightRotation, 0),
      count: clamp(Math.round(read(ARROW_PROPERTIES.rightCount, 4)), 1, 4),
      scale: clamp(read(ARROW_PROPERTIES.rightScale, 1), 0.1, 8),
      symbol: readSymbol(ARROW_PROPERTIES.rightSymbol, rightCustom.customSymbol),
      customSvg: rightCustom.customSvg,
      customName: rightCustom.customName,
      colorize: readBoolean(ARROW_PROPERTIES.rightColorize, false),
      arrowColor: readColor(ARROW_PROPERTIES.rightArrowColor, optionArrowColor),
      labelColor: readColor(ARROW_PROPERTIES.rightLabelColor, optionLabelColor)
    };
    for (const side of ['left','right']) {
      const raw=readText(ARROW_PROPERTIES[`${side}Label`]);
      try { arrowState[side].label=raw?window.SmoofArrowLabels.normalize(JSON.parse(raw)):window.SmoofArrowLabels.defaults(); } catch { arrowState[side].label=window.SmoofArrowLabels.defaults(); }
    }
    syncLabels();
    arrowState.left.scale = Math.min(arrowState.left.scale, maximumPictogramScale('left', arrowState.left));
    arrowState.right.scale = Math.min(arrowState.right.scale, maximumPictogramScale('right', arrowState.right));
    Object.assign(arrowState.left, constrainArrowPosition('left', arrowState.left));
    Object.assign(arrowState.right, constrainArrowPosition('right', arrowState.right));
  }

  function saveArrowState() {
    syncLabels();
    const form = productForm();
    if (!form) return;
    const inputs = new Map();
    form.querySelectorAll('input').forEach(input => {
      if (!inputs.has(input.name)) inputs.set(input.name, input);
    });
    const writeProperty = (name, value) => setArrowProperty(name, value, form, inputs);
    writeProperty(
      ARROW_PROPERTIES.visible,
      arrowState.left.visible || arrowState.right.visible ? 'Ja' : 'Nein'
    );
    writeProperty(ARROW_PROPERTIES.leftX, arrowState.left.x.toFixed(4));
    writeProperty(ARROW_PROPERTIES.leftY, arrowState.left.y.toFixed(4));
    writeProperty(ARROW_PROPERTIES.rightX, arrowState.right.x.toFixed(4));
    writeProperty(ARROW_PROPERTIES.rightY, arrowState.right.y.toFixed(4));
    ['left', 'right'].forEach(side => {
      const state = arrowState[side];
      const prefix = side === 'left' ? 'left' : 'right';
      writeProperty(ARROW_PROPERTIES[`${prefix}Visible`], state.visible ? 'Ja' : 'Nein');
      writeProperty(ARROW_PROPERTIES[`${prefix}Label`], JSON.stringify(state.label));
      writeProperty(ARROW_PROPERTIES[`${prefix}LabelVisible`], state.labelVisible ? 'Ja' : 'Nein');
      writeProperty(ARROW_PROPERTIES[`${prefix}Rotation`], state.rotation.toFixed(1));
      writeProperty(ARROW_PROPERTIES[`${prefix}Count`], String(state.count));
      writeProperty(ARROW_PROPERTIES[`${prefix}Scale`], pictogramScale(state).toFixed(4));
      writeProperty(ARROW_PROPERTIES[`${prefix}Symbol`], state.symbol || 'dots');
      writeProperty(ARROW_PROPERTIES[`${prefix}CustomSvg`], state.customSvg || '');
      writeProperty(ARROW_PROPERTIES[`${prefix}CustomName`], state.customName || '');
      writeProperty(ARROW_PROPERTIES[`${prefix}Colorize`], state.colorize ? 'Ja' : 'Nein');
      writeProperty(ARROW_PROPERTIES[`${prefix}ArrowColor`], state.arrowColor);
      writeProperty(ARROW_PROPERTIES[`${prefix}LabelColor`], state.labelColor);
    });
  }

  function constrainArrowPosition(side, position) {
    const rotation = Number(position.rotation ?? arrowState[side]?.rotation ?? 0);
    const combinedState = { ...arrowState[side], ...position };
    const labelVisible = pictogramIsStandard(combinedState) &&
      (position.labelVisible ?? arrowState[side]?.labelVisible ?? true);
    const metrics = arrowVisualMetrics(side, combinedState);
    const visualWidth = metrics.width;
    const visualHeight = pictogramVisualHeight(
      combinedState,
      labelVisible
    );
    const radians = rotation * Math.PI / 180;
    const rotatedWidth = Math.abs(visualWidth * Math.cos(radians)) +
      Math.abs(visualHeight * Math.sin(radians));
    const rotatedHeight = Math.abs(visualWidth * Math.sin(radians)) +
      Math.abs(visualHeight * Math.cos(radians));
    const halfWidth = visualWidth / 2;
    const halfHeight = visualHeight / 2;
    const halfRotatedWidth = rotatedWidth / 2;
    const halfRotatedHeight = rotatedHeight / 2;
    const wanted = {
      x: position.x + metrics.offsetX + halfWidth,
      y: position.y + halfHeight
    };
    const center = window.SmoofSpatialConstraints?.constrainRect({
      ...wanted,
      halfWidth: halfRotatedWidth,
      halfHeight: halfRotatedHeight,
      radius: pictogramConstraintRadius(),
      allowOutsidePrintRadius: true
    }) || wanted;
    return {
      x: center.x - halfWidth - metrics.offsetX,
      y: center.y - halfHeight
    };
  }

  function maximumPictogramScale(side, state) {
    const canFit = scale => {
      const candidate = { ...state, scale };
      const width = arrowVisualWidth(candidate);
      const height = pictogramVisualHeight(
        candidate,
        pictogramIsStandard(candidate) && candidate.labelVisible
      );
      const radians = (Number(candidate.rotation) || 0) * Math.PI / 180;
      const halfRotatedWidth = (Math.abs(width * Math.cos(radians)) + Math.abs(height * Math.sin(radians))) / 2;
      const halfRotatedHeight = (Math.abs(width * Math.sin(radians)) + Math.abs(height * Math.cos(radians))) / 2;
      return window.SmoofSpatialConstraints?.constrainRect({
        x: 0.5,
        y: 0.5,
        halfWidth: halfRotatedWidth,
        halfHeight: halfRotatedHeight,
        radius: pictogramConstraintRadius(),
        allowOutsidePrintRadius: true
      }).valid !== false;
    };
    let low = 0.1;
    let high = 8;
    for (let index = 0; index < 28; index += 1) {
      const middle = (low + high) / 2;
      if (canFit(middle)) low = middle;
      else high = middle;
    }
    return low;
  }

  function removeOverlay() {
    arrowColorControl?.remove();
    nativeEraserOverlay?.remove();
    overlay?.remove();
    nativeEraserOverlay = null;
    overlay = null;
    arrowColorControl = null;
    guideX = null;
    guideY = null;
    currentStage = null;
  }

  function setArrowGuides(x = null, y = null) {
    const sharedGuides = window.SmoofAlignmentGuides;
    if (sharedGuides) {
      if (guideX) guideX.style.display = 'none';
      if (guideY) guideY.style.display = 'none';
      if (Number.isFinite(x)) sharedGuides.showX(x);
      else sharedGuides.hideX();
      if (Number.isFinite(y)) sharedGuides.showY?.(y);
      else sharedGuides.hideY?.();
    } else if (guideX) {
      guideX.style.display = Number.isFinite(x) ? 'block' : 'none';
      if (Number.isFinite(x)) guideX.style.left = `${x * 100}%`;
    }
    if (guideY) {
      guideY.style.display = Number.isFinite(y) ? 'block' : 'none';
      if (Number.isFinite(y)) guideY.style.top = `${y * 100}%`;
    }
  }

  function snapCandidates(side) {
    const stageRect = currentStage?.getBoundingClientRect();
    const visualHeight = pictogramVisualHeight(
      arrowState[side],
      arrowState[side].labelVisible
    );
    const x = window.SmoofAlignmentGuides
      ? [...window.SmoofAlignmentGuides.targets]
      : [0.2593, 0.5, 0.7407];
    const y = window.SmoofAlignmentGuides?.targetsY
      ? [...window.SmoofAlignmentGuides.targetsY, ARROW_DEFAULTS[side].y + visualHeight / 2]
      : [0.2593, 0.5, 0.7407, ARROW_DEFAULTS[side].y + visualHeight / 2];
    if (!stageRect?.width || !stageRect?.height) return { x, y };
    document.querySelectorAll([
      '[data-smoof-text-frame]',
      '[data-smoof-logo-editor-frame]',
      '[data-smoof-number-frame]',
      '[data-smoof-brand-dot]',
      '[data-smoof-nfc-frame]'
    ].join(',')).forEach(element => {
      if (element.closest(`[data-smoof-arrow-graphic="${side}"]`)) return;
      const style = getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      if (style.display === 'none' || style.visibility === 'hidden' || rect.width < 2 || rect.height < 2) return;
      x.push((rect.left + rect.width / 2 - stageRect.left) / stageRect.width);
      y.push((rect.top + rect.height / 2 - stageRect.top) / stageRect.height);
    });
    return { x, y };
  }

  function snapArrowPosition(side, position) {
    const state = arrowState[side];
    const metrics = arrowVisualMetrics(side, state);
    const width = metrics.width;
    const height = pictogramVisualHeight(
      state,
      state.labelVisible
    );
    let centerX = position.x + metrics.offsetX + width / 2;
    let centerY = position.y + height / 2;
    const candidates = snapCandidates(side);
    const nearest = (value, values) => values
      .map(candidate => ({ candidate, distance: Math.abs(candidate - value) }))
      .sort((a, b) => a.distance - b.distance)[0];
    const snapX = nearest(centerX, candidates.x);
    const snapY = nearest(centerY, candidates.y);
    const guideAtX = window.SmoofAlignmentGuides?.isAxisEnabled?.('x') !== false && snapX?.distance <= SNAP_THRESHOLD ? snapX.candidate : null;
    const guideAtY = window.SmoofAlignmentGuides?.isAxisEnabled?.('y') !== false && snapY?.distance <= SNAP_THRESHOLD ? snapY.candidate : null;
    if (Number.isFinite(guideAtX)) centerX = guideAtX;
    if (Number.isFinite(guideAtY)) centerY = guideAtY;
    setArrowGuides(guideAtX, guideAtY);
    return {
      x: centerX - width / 2 - metrics.offsetX,
      y: centerY - height / 2
    };
  }

  function setNativeColorValue(
    input,
    value,
    commit = false
  ) {
    if (!input) return;

    const descriptor =
      Object.getOwnPropertyDescriptor(
        HTMLInputElement.prototype,
        'value'
      );

    if (descriptor?.set) {
      descriptor.set.call(
        input,
        value
      );
    } else {
      input.value = value;
    }

    input.dispatchEvent(
      new Event(
        'input',
        {
          bubbles: true
        }
      )
    );

    if (commit) {
      input.dispatchEvent(
        new Event(
          'change',
          {
            bubbles: true
          }
        )
      );
    }
  }

  function applyArrowSelection(id) {
    const value = String(id || '');
    const match = /^arrow-(left|right)$/.exec(value);
    arrowsSelected = Boolean(match) || value === 'arrows';
    if (match) activeArrowSide = match[1];

    const modernUiActive =
      document.documentElement
        .dataset
        .smoofUiShellReady === 'true';

    if (!overlay) return;

    overlay.dataset.active =
      String(arrowsSelected);

    overlay.style.zIndex =
      arrowsSelected ? '80' : '60';

    overlay
      .querySelectorAll(
        '[data-smoof-arrow-graphic]'
      )
      .forEach(graphic => {
        graphic.dataset.active =
          String(arrowsSelected && graphic.dataset.smoofArrowGraphic === activeArrowSide);
      });

    if (arrowColorControl) {
      arrowColorControl.style.setProperty(
        'opacity',
        arrowsSelected && !modernUiActive
          ? '1'
          : '0',
        'important'
      );

      arrowColorControl.style.setProperty(
        'visibility',
        arrowsSelected
          && !modernUiActive
          ? 'visible'
          : 'hidden',
        'important'
      );

      arrowColorControl.style.setProperty(
        'pointer-events',
        arrowsSelected
          && !modernUiActive
          ? 'auto'
          : 'none',
        'important'
      );
    }

    overlay
      .querySelectorAll(
        '[data-smoof-arrow-selection-frame]'
      )
      .forEach(frame => {
        const frameSide = frame.dataset.smoofArrowSelectionFrame;
        const selected = arrowsSelected && frameSide === activeArrowSide;
        frame.style.setProperty(
          'display',
          selected && arrowState[frameSide]?.visible
            ? 'block'
            : 'none',
          'important'
        );

        frame.style.setProperty(
          'opacity',
          selected && arrowState[frameSide]?.visible
            ? '1'
            : '0',
          'important'
        );

        frame.style.setProperty(
          'visibility',
          selected && arrowState[frameSide]?.visible
            ? 'visible'
            : 'hidden',
          'important'
        );
      });
  }

  function selectArrows(side = activeArrowSide) {
    activeArrowSide = side === 'right' ? 'right' : 'left';
    window.dispatchEvent(
      new CustomEvent(
        EDITOR_SELECTION_EVENT,
        {
          detail: {
            id: `arrow-${activeArrowSide}`
          }
        }
      )
    );
  }

  function createArrowColorControl() {
    const wrapper =
      document.createElement('div');

    wrapper.dataset.smoofArrowControls =
      'true';

    wrapper.dataset.smoofEditorItem =
      'arrows';

    const arrowGroup =
      document.createElement('label');

    arrowGroup.dataset.smoofArrowColorGroup =
      'arrow';

    const arrowCaption =
      document.createElement('span');

    arrowCaption.textContent =
      window.SmoofI18n.copy('Pfeil', 'Arrow');

    const input =
      document.createElement('input');

    input.type = 'color';
    input.dataset.smoofArrowColorInput =
      'true';

    input.setAttribute(
      'aria-label',
      window.SmoofI18n.legacy('Farbe der Pfeile')
    );

    input.setAttribute(
      'title',
      window.SmoofI18n.legacy('Farbe der Pfeile')
    );

    input.addEventListener(
      'pointerdown',
      event => {
        event.stopPropagation();
        selectArrows(activeArrowSide);
      }
    );

    input.addEventListener(
      'input',
      event => {
        event.stopPropagation();

        arrowState[activeArrowSide].arrowColor = input.value;
        saveArrowState();
        scheduleRender();
      }
    );

    input.addEventListener(
      'change',
      event => {
        event.stopPropagation();

        arrowState[activeArrowSide].arrowColor = input.value;
        saveArrowState();
        window.SmoofDesignRenderer?.scheduleRender?.();
      }
    );

    arrowGroup.append(
      arrowCaption,
      input
    );

    const labelGroup =
      document.createElement('label');

    labelGroup.dataset.smoofArrowColorGroup =
      'label';

    const labelCaption =
      document.createElement('span');

    labelCaption.textContent = 'Text';

    const labelInput =
      document.createElement('input');

    labelInput.type = 'color';
    labelInput.dataset
      .smoofArrowLabelColorInput =
      'true';

    labelInput.setAttribute(
      'aria-label',
      window.SmoofI18n.legacy('Farbe von TAP und SCAN')
    );

    labelInput.setAttribute(
      'title',
      window.SmoofI18n.legacy('Farbe von TAP und SCAN')
    );

    labelInput.addEventListener(
      'pointerdown',
      event => {
        event.stopPropagation();
        selectArrows(activeArrowSide);
      }
    );

    labelInput.addEventListener(
      'input',
      event => {
        event.stopPropagation();

        arrowState[activeArrowSide].labelColor = labelInput.value;
        saveArrowState();
        scheduleRender();
      }
    );

    labelInput.addEventListener(
      'change',
      event => {
        event.stopPropagation();

        arrowState[activeArrowSide].labelColor = labelInput.value;
        saveArrowState();
        window.SmoofDesignRenderer?.scheduleRender?.();
      }
    );

    labelGroup.append(
      labelCaption,
      labelInput
    );

    wrapper.append(
      arrowGroup,
      labelGroup
    );

    return wrapper;
  }

  function isMobileArrowEditor() {
    return window.matchMedia(
      '(max-width: 749px)'
    ).matches;
  }

  function updateArrowGeometry() {
    syncLabels();
    if (!overlay) return;
    ['left', 'right'].forEach(side => {
      const position = arrowState[side];
      const standard = pictogramIsStandard(position);
      const hasLabel = standard && position.labelVisible;
      const metrics = arrowVisualMetrics(side, position);
      const visibleFraction = standard
        ? metrics.width / (ARROW_SIZE.width * pictogramScale(position))
        : 1;
      const visibleLeft = position.x + metrics.offsetX;
      const visibleCenter = visibleLeft + metrics.width / 2;
      const arrowHeight = pictogramGraphicHeight(position);
      const arrowGraphic = overlay.querySelector(`[data-smoof-arrow-graphic="${side}"]`);
      if (arrowGraphic) {
        const maskScale = 100 / visibleFraction;
        const iconRecord = window.SmoofPictogramLibrary?.get?.(position.symbol);
        const originalRaster = iconRecord?.raster === true && position.colorize !== true;
        const iconUrl = standard
          ? (side === 'left' ? LEFT_URL : RIGHT_URL)
          : window.SmoofPictogramLibrary?.dataUrl?.(position.symbol, side);
        arrowGraphic.style.clipPath = 'none';
        arrowGraphic.style.webkitClipPath = 'none';
        arrowGraphic.style.left = `${visibleLeft * 100}%`;
        arrowGraphic.style.top = `${position.y * 100}%`;
        arrowGraphic.style.width = `${metrics.width * 100}%`;
        arrowGraphic.style.height = `${arrowHeight * 100}%`;
        arrowGraphic.style.aspectRatio = 'auto';
        arrowGraphic.style.backgroundImage = originalRaster && iconUrl ? `url("${iconUrl}")` : 'none';
        arrowGraphic.style.backgroundRepeat = 'no-repeat';
        arrowGraphic.style.backgroundPosition = 'center';
        arrowGraphic.style.backgroundSize = 'contain';
        arrowGraphic.style.maskImage = !originalRaster && iconUrl ? `url("${iconUrl}")` : 'none';
        arrowGraphic.style.webkitMaskImage = !originalRaster && iconUrl ? `url("${iconUrl}")` : 'none';
        const standardMaskHeight = `${100 / ARROW_ONLY_HEIGHT_FACTOR}%`;
        const standardMaskSize = `${maskScale}% ${standardMaskHeight}`;
        arrowGraphic.style.maskSize = standard ? standardMaskSize : 'contain';
        arrowGraphic.style.webkitMaskSize = standard ? standardMaskSize : 'contain';
        arrowGraphic.style.maskPosition = standard
          ? (side === 'left' ? 'right top' : 'left top')
          : 'center';
        arrowGraphic.style.webkitMaskPosition = arrowGraphic.style.maskPosition;
        arrowGraphic.style.setProperty('-webkit-mask-image', !originalRaster && iconUrl ? `url("${iconUrl}")` : 'none');
        arrowGraphic.style.setProperty('-webkit-mask-size', standard ? standardMaskSize : 'contain');
        arrowGraphic.style.setProperty(
          '-webkit-mask-position',
          standard
            ? (side === 'left' ? 'right top' : 'left top')
            : 'center'
        );
        arrowGraphic.dataset.smoofPictogramRaster = String(iconRecord?.raster === true);
        arrowGraphic.dataset.smoofPictogramColorize = String(position.colorize === true);
        arrowGraphic.style.removeProperty('rotate');
        arrowGraphic.style.setProperty('transform', `rotate(${position.rotation}deg)`, 'important');
        arrowGraphic.style.setProperty(
          'transform-origin',
          hasLabel
            ? `50% ${(pictogramVisualHeight(position, true) / 2 / arrowHeight) * 100}%`
            : '50% 50%',
          'important'
        );
      }
      const labelGraphic = overlay.querySelector(`[data-smoof-arrow-label-graphic="${side}"]`);
      if (labelGraphic) {
        const labelWidth = ARROW_SIZE.width * pictogramScale(position);
        labelGraphic.style.left = `${(visibleCenter - labelWidth / 2) * 100}%`;
        labelGraphic.style.top = `${position.y * 100}%`;
        labelGraphic.style.width = `${labelWidth * 100}%`;
        labelGraphic.style.height = `${ARROW_SIZE.height*pictogramScale(position)*100}%`;
        window.SmoofArrowLabels.paint(labelGraphic,position,side,side==='left'?LEFT_URL:RIGHT_URL);
        labelGraphic.style.removeProperty('rotate');
        labelGraphic.style.setProperty('transform', `rotate(${position.rotation}deg)`, 'important');
        labelGraphic.style.setProperty('transform-origin', '50% 50%', 'important');
        labelGraphic.hidden = !hasLabel;
        labelGraphic.style.setProperty('display', hasLabel ? 'block' : 'none', 'important');
      }
      const selection = overlay.querySelector(`[data-smoof-arrow-selection-frame="${side}"]`);
      if (selection) {
        selection.style.left = `${(visibleLeft - 0.0048) * 100}%`;
        selection.style.top = `${(position.y - 0.0047) * 100}%`;
        selection.style.right = 'auto';
        selection.style.width = `${(metrics.width + 0.0096) * 100}%`;
        selection.style.height = `${(pictogramVisualHeight(position, hasLabel) + 0.0094) * 100}%`;
        selection.style.aspectRatio = 'auto';
        selection.style.removeProperty('rotate');
        selection.style.setProperty('transform', `rotate(${position.rotation}deg)`, 'important');
        selection.style.setProperty('transform-origin', '50% 50%', 'important');
      }
    });
  }

  function startArrowDrag(event, side) {
    if (event.button !== 0) return;
    selectArrows(side);
    const start = arrowState[side];
    activeArrowDrag = {
      side,
      pointerId: event.pointerId,
      clientX: event.clientX,
      clientY: event.clientY,
      x: start.x,
      y: start.y,
      moved: false
    };
    document.documentElement.dataset.smoofUiDragging = 'true';
    event.currentTarget.setPointerCapture?.(event.pointerId);
    event.preventDefault();
    event.stopPropagation();
  }

  function moveArrowDrag(event) {
    const drag = activeArrowDrag;
    if (!drag || drag.pointerId !== event.pointerId || !currentStage) return;
    const rect = currentStage.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    const dx = (event.clientX - drag.clientX) / rect.width;
    const dy = (event.clientY - drag.clientY) / rect.height;
    drag.moved = drag.moved || Math.hypot(dx, dy) > 0.003;
    let next = constrainArrowPosition(drag.side, {
      x: drag.x + dx,
      y: drag.y + dy
    });
    next = snapArrowPosition(drag.side, next);
    next = constrainArrowPosition(drag.side, next);
    const defaultPosition = ARROW_DEFAULTS[drag.side];
    if (window.SmoofAlignmentGuides?.isAxisEnabled?.('y') !== false && Math.abs(next.y - defaultPosition.y) <= SNAP_THRESHOLD) next.y = defaultPosition.y;
    Object.assign(arrowState[drag.side], next);
    updateArrowGeometry();
    saveArrowState();
    event.preventDefault();
    event.stopPropagation();
  }

  function finishArrowDrag(event) {
    const drag = activeArrowDrag;
    if (!drag || drag.pointerId !== event.pointerId) return;
    activeArrowDrag = null;
    document.documentElement.removeAttribute('data-smoof-ui-dragging');
    setArrowGuides();
    event.currentTarget.releasePointerCapture?.(event.pointerId);
    saveArrowState();
    window.SmoofDesignRenderer?.scheduleRender?.();
    event.preventDefault();
    event.stopPropagation();
  }

  function createGraphic(
    url,
    side,
    offset,
    ratio
  ) {
    const graphic = document.createElement('div');

    graphic.dataset.smoofArrowGraphic =
      side;

    graphic.dataset.smoofArrowRatio = ratio;

    graphic.dataset.smoofEditorItem =
      `arrow-${side}`;

    graphic.dataset.active = 'false';

    graphic.setAttribute(
      'role',
      'button'
    );

    graphic.setAttribute(
      'aria-label',
      window.SmoofI18n.legacy('Pfeile und Beschriftung auswählen')
    );

    graphic.tabIndex = 0;

    Object.assign(graphic.style, {
      position: 'absolute',
      display: 'block',

      /*
       * Symmetrische Positionen der neuen,
       * auf 50 % zentrierten Vorlage.
       */
      top: '47.31%',
      width: '14.56%',
      aspectRatio: ratio,

      backgroundColor: '#000000',
      pointerEvents: 'auto',
      cursor: 'pointer',
      touchAction: 'none',

      webkitMaskImage: `url("${url}")`,
      maskImage: `url("${url}")`,

      webkitMaskRepeat: 'no-repeat',
      maskRepeat: 'no-repeat',

      webkitMaskPosition: 'center',
      maskPosition: 'center',

      webkitMaskSize: 'contain',
      maskSize: 'contain',

      /*
       * Das Original-SVG enthält sowohl
       * die Punkte als auch TAP/SCAN.
       * Dieser Ausschnitt zeigt nur die
       * eigentliche Pfeilgrafik.
       */
      clipPath: 'none',
      WebkitClipPath: 'none'
    });

    graphic.style.left = `${arrowState[side].x * 100}%`;
    graphic.style.top = `${arrowState[side].y * 100}%`;
    graphic.style.setProperty('-webkit-mask-image', `url("${url}")`);
    graphic.style.setProperty('-webkit-mask-repeat', 'no-repeat');
    graphic.style.setProperty('-webkit-mask-position', 'center top');
    graphic.style.setProperty('-webkit-mask-size', 'contain');

    graphic.addEventListener(
      'pointerdown',
      event => {
        startArrowDrag(event, side);
      }
    );

    graphic.addEventListener('pointermove', moveArrowDrag);
    graphic.addEventListener('pointerup', finishArrowDrag);
    graphic.addEventListener('pointercancel', finishArrowDrag);

    graphic.addEventListener(
      'keydown',
      event => {
        if (
          event.key === 'Enter' ||
          event.key === ' '
        ) {
          event.preventDefault();
          selectArrows(side);
        }
      }
    );

    return graphic;
  }

  function createLabelGraphic(
    url,
    side,
    offset,
    ratio
  ) {
    const graphic =
      document.createElement('div');

    graphic.dataset.smoofArrowLabelGraphic =
      side;

    Object.assign(graphic.style, {
      position: 'absolute',
      display: 'block',
      top: '47.31%',
      width: '14.56%',
      aspectRatio: ratio,
      backgroundColor: '#000000',
      pointerEvents: 'none',

      webkitMaskImage: `url("${url}")`,
      maskImage: `url("${url}")`,

      webkitMaskRepeat: 'no-repeat',
      maskRepeat: 'no-repeat',

      webkitMaskPosition: 'center',
      maskPosition: 'center',

      webkitMaskSize: 'contain',
      maskSize: 'contain',

      /*
       * Derselbe SVG-Ausschnitt, diesmal
       * ausschließlich für TAP bzw. SCAN.
       */
      clipPath: 'inset(80% 0 0 0)',
      WebkitClipPath: 'inset(80% 0 0 0)'
    });

    graphic.style.left = `${arrowState[side].x * 100}%`;
    graphic.style.top = `${arrowState[side].y * 100}%`;
    graphic.style.setProperty('-webkit-mask-image', `url("${url}")`);
    graphic.style.setProperty('-webkit-mask-repeat', 'no-repeat');
    graphic.style.setProperty('-webkit-mask-position', 'center');
    graphic.style.setProperty('-webkit-mask-size', 'contain');

    return graphic;
  }

  function createSelectionFrame(
    side,
    ratio
  ) {
    const frame =
      document.createElement('div');

    frame.dataset
      .smoofArrowSelectionFrame =
      side;

    frame.dataset
      .smoofArrowSelectionRatio =
      ratio;

    Object.assign(
      frame.style,
      {
        top: '46.84%',
        width: '15.52%',
        aspectRatio: ratio
      }
    );

    frame.style.left = `${(arrowState[side].x - 0.0048) * 100}%`;
    frame.style.top = `${(arrowState[side].y - 0.0047) * 100}%`;

    return frame;
  }

  function ensureOverlay(stage) {
    if (
      overlay?.isConnected &&
      nativeEraserOverlay?.isConnected &&
      arrowColorControl?.isConnected &&
      currentStage === stage
    ) {
      return;
    }

    removeOverlay();

    nativeEraserOverlay = document.createElement('div');
    nativeEraserOverlay.dataset.smoofNativeArrowEraserOverlay = 'true';
    nativeEraserOverlay.setAttribute('aria-hidden', 'true');

    Object.assign(nativeEraserOverlay.style, {
      position: 'absolute',
      display: 'block',
      inset: '0',
      zIndex: '50',
      pointerEvents: 'none',
      clipPath: 'circle(35.34% at 50% 50%)'
    });

    nativeEraserOverlay.style.setProperty(
      '-webkit-clip-path',
      'circle(35.34% at 50% 50%)'
    );

    overlay = document.createElement('div');
    overlay.dataset.smoofArrowOverlay = 'true';
    overlay.dataset.active =
      String(arrowsSelected);

    Object.assign(overlay.style, {
      position: 'absolute',
      display: 'block',
      inset: '0',
      zIndex: '60',
      pointerEvents: 'none'
    });

    const leftGraphic = createGraphic(
      LEFT_URL,
      'left',
      '18.98%',
      '85.01 / 48.27'
    );

    const rightGraphic = createGraphic(
      RIGHT_URL,
      'right',
      '18.98%',
      '85.01 / 48.34'
    );

    const leftLabelGraphic =
      createLabelGraphic(
        LEFT_URL,
        'left',
        '18.98%',
        '85.01 / 48.27'
      );

    const rightLabelGraphic =
      createLabelGraphic(
        RIGHT_URL,
        'right',
        '18.98%',
        '85.01 / 48.34'
      );

    const leftSelectionFrame =
      createSelectionFrame(
        'left',
        '85.01 / 48.27'
      );

    const rightSelectionFrame =
      createSelectionFrame(
        'right',
        '85.01 / 48.34'
      );

    const leftNativeEraser =
      createNativeArrowEraser(
        'left'
      );

    const rightNativeEraser =
      createNativeArrowEraser(
        'right'
      );

    arrowColorControl =
      createArrowColorControl();

    guideX = document.createElement('div');
    guideX.dataset.smoofArrowSnapGuide = 'x';
    guideX.setAttribute('aria-hidden', 'true');
    guideY = document.createElement('div');
    guideY.dataset.smoofArrowSnapGuide = 'y';
    guideY.setAttribute('aria-hidden', 'true');

    nativeEraserOverlay.append(
      leftNativeEraser,
      rightNativeEraser
    );

    overlay.append(
      guideX,
      guideY,
      leftSelectionFrame,
      rightSelectionFrame,
      leftGraphic,
      rightGraphic,
      leftLabelGraphic,
      rightLabelGraphic
    );

    stage.appendChild(nativeEraserOverlay);
    stage.appendChild(overlay);

    if (isMobileArrowEditor()) {
      document.body.appendChild(
        arrowColorControl
      );
    } else {
      overlay.appendChild(
        arrowColorControl
      );
    }

    currentStage = stage;

    applyArrowSelection(
      arrowsSelected
        ? `arrow-${activeArrowSide}`
        : ''
    );
  }

  function render() {
    syncLabels();
    if (!arrowStateHydrated && productForm()) {
      loadArrowState();
      arrowStateHydrated = true;
      saveArrowState();
    }
    const marker =
      document.querySelector(
        '#smoof-preview-extension'
      );

    const option =
      document.querySelector(
        OPTION_SELECTOR
      );

    const stage =
      document.querySelector(
        '.po-livePreview-stage .konvajs-content'
      );

    const colorInput =
      option?.querySelector(
        'input[type="color"]'
      );

    const labelColorInput =
      document.querySelector(
        LABEL_OPTION_SELECTOR
      )?.querySelector(
        'input[type="color"]'
      );

    const showLabels = true;

    const showActiveLabelControls =
      showLabels &&
      pictogramIsStandard(arrowState[activeArrowSide]);

    const labelOption =
      document.querySelector(
        LABEL_OPTION_SELECTOR
      );

    if (labelOption) {
      if (showActiveLabelControls) {
        labelOption.style.removeProperty(
          'display'
        );
        labelOption.removeAttribute(
          'aria-hidden'
        );
      } else {
        labelOption.style.setProperty(
          'display',
          'none',
          'important'
        );
        labelOption.setAttribute(
          'aria-hidden',
          'true'
        );
      }
    }

    if (
      !marker ||
      !option ||
      !stage ||
      !colorInput ||
      (
        showActiveLabelControls &&
        !labelColorInput
      )
    ) {
      removeOverlay();
      return;
    }

    suppressNativeArrowNodes(marker);
    ensureOverlay(stage);
    updateNativeArrowErasers();
    ['left', 'right'].forEach(side => {
      Object.assign(arrowState[side], constrainArrowPosition(side, arrowState[side]));
    });
    updateArrowGeometry();

    const color = arrowState[activeArrowSide]?.arrowColor || colorInput.value || '#000000';

    const labelColor = arrowState[activeArrowSide]?.labelColor || labelColorInput?.value || '#000000';

    arrowColorControl.dataset
      .smoofNfcLabelsVisible =
      String(showActiveLabelControls);

    const labelColorGroup =
      arrowColorControl.querySelector(
        '[data-smoof-arrow-color-group="label"]'
      );

    if (labelColorGroup) {
      labelColorGroup.style.setProperty(
        'display',
        showActiveLabelControls ? 'flex' : 'none',
        'important'
      );

      labelColorGroup.setAttribute(
        'aria-hidden',
        String(!showActiveLabelControls)
      );
    }

    overlay
      .querySelectorAll(
        '[data-smoof-arrow-graphic]'
      )
      .forEach(graphic => {
        const side = graphic.dataset.smoofArrowGraphic;
        const state = arrowState[side];
        const iconRecord = window.SmoofPictogramLibrary?.get?.(state.symbol);
        const originalRaster = iconRecord?.raster === true && state.colorize !== true;
        graphic.style.display = state.visible ? 'block' : 'none';
        graphic.style.backgroundColor = originalRaster ? 'transparent' : state.arrowColor;
        graphic.dataset.smoofArrowVisible = String(state.visible);
        graphic.dataset.smoofArrowRotation = String(state.rotation);
        graphic.dataset.smoofArrowCount = String(state.count);
        graphic.dataset.smoofPictogramScale = String(pictogramScale(state));
        graphic.dataset.smoofPictogram = state.symbol || 'dots';

        graphic.setAttribute(
          'aria-label',
          showLabels && pictogramIsStandard(state)
            ? window.SmoofI18n.legacy('Piktogramm und Beschriftung auswählen')
            : window.SmoofI18n.legacy('Piktogramm auswählen')
        );
      });

    overlay
      .querySelectorAll(
        '[data-smoof-arrow-label-graphic]'
      )
      .forEach(graphic => {
        const side = graphic.dataset.smoofArrowLabelGraphic;
        const state = arrowState[side];
        const labelVisible = showLabels && pictogramIsStandard(state) && state.visible && state.labelVisible;
        graphic.hidden = !labelVisible;
        graphic.style.setProperty('display', labelVisible ? 'block' : 'none', 'important');
        graphic.style.backgroundColor =
          labelVisible
            ? state.labelColor
            : 'transparent';
        graphic.dataset.smoofArrowLabelVisible = String(labelVisible);
      });

    overlay
      .querySelectorAll(
        '[data-smoof-arrow-selection-frame]'
      )
      .forEach(frame => {
        const side = frame.dataset.smoofArrowSelectionFrame;
        const state = arrowState[side];
        if (!state.visible) {
          frame.style.setProperty('display', 'none', 'important');
          return;
        }
        frame.style.aspectRatio = 'auto';
      });

    if (
      arrowColorControl &&
      document.activeElement !==
        arrowColorControl
          .querySelector(
            '[data-smoof-arrow-color-input]'
          )
    ) {
      arrowColorControl
        .querySelector(
          '[data-smoof-arrow-color-input]'
        )
        .value = color;
    }

    if (
      arrowColorControl &&
      document.activeElement !==
        arrowColorControl
          .querySelector(
            '[data-smoof-arrow-label-color-input]'
          )
    ) {
      arrowColorControl
        .querySelector(
          '[data-smoof-arrow-label-color-input]'
        )
        .value = labelColor;
    }

    marker.dataset.smoofArrowStatus =
      'active';

    marker.dataset.smoofArrowVersion =
      'editable-arrows-v23-panel-free-drag';

    marker.dataset.smoofArrowLabels =
      showLabels ? 'visible' : 'hidden';

    marker.dataset.smoofNativeArrowNodes =
      String(nativeArrowNodesHidden);

    marker.dataset.smoofNativeArrowEraser =
      nativeEraserOverlay.querySelectorAll(
        '[data-smoof-native-arrow-eraser]'
      ).length === 2
        ? 'active'
        : 'incomplete';

    marker.dataset.smoofNativeArrowLayer =
      marker.dataset.smoofNativeArrowEraser === 'active'
        ? 'covered'
        : marker.dataset.smoofNativeArrowLayer;
  }

  function scheduleRender() {
    if (renderPending) return;

    renderPending = true;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        renderPending = false;
        render();
      });
    });
  }

  window.SmoofArrowTools = {

previewNudge(side,dx,dy) { const state=arrowState[side];return state?.visible?constrainArrowPosition(side,{x:state.x+dx,y:state.y+dy}):null; },
    nudge(side, dx, dy) {
      const state = arrowState[side];
      if (!state?.visible) return false;
      Object.assign(state, constrainArrowPosition(side, { x: state.x + dx, y: state.y + dy }));
      updateArrowGeometry(); saveArrowState();
      window.SmoofDesignRenderer?.scheduleRender?.();
      return true;
    },
    isVisible(side) {
      if (side === 'left' || side === 'right') return arrowState[side].visible;
      return arrowState.left.visible || arrowState.right.visible;
    },
    toggleVisibility(side = activeArrowSide) {
      if (side !== 'left' && side !== 'right') side = activeArrowSide;
      arrowState[side].visible = !arrowState[side].visible;
      saveArrowState();
      scheduleRender();
      window.SmoofDesignRenderer?.scheduleRender?.();
      window.dispatchEvent(new CustomEvent('smoof:arrow-visibility-changed', {
        detail: { side, visible: arrowState[side].visible }
      }));
      return arrowState[side].visible;
    },
    resetPosition(side) {
      if (side === 'left' || side === 'right') {
        arrowState[side] = { ...ARROW_DEFAULTS[side] };
      } else {
        arrowState.left = { ...ARROW_DEFAULTS.left };
        arrowState.right = { ...ARROW_DEFAULTS.right };
      }
      saveArrowState();
      updateArrowGeometry();
      scheduleRender();
      window.SmoofDesignRenderer?.scheduleRender?.();
    },
    setColor(side, kind, value, commit = false) {
      if (side !== 'left' && side !== 'right') {
        commit = value || false;
        value = kind;
        kind = side;
        side = activeArrowSide;
      }
      if (!/^#[0-9a-f]{6}$/i.test(String(value))) return false;
      arrowState[side][kind === 'label' ? 'labelColor' : 'arrowColor'] = value;
      saveArrowState();
      scheduleRender();
      if (commit) window.SmoofDesignRenderer?.scheduleRender?.();
      return true;
    },
    setRotation(side, value) {
      if (side !== 'left' && side !== 'right') return false;
      arrowState[side].rotation = ((Number(value) % 360) + 360) % 360;
      arrowState[side].scale = Math.min(
        pictogramScale(arrowState[side]),
        maximumPictogramScale(side, arrowState[side])
      );
      Object.assign(arrowState[side], constrainArrowPosition(side, arrowState[side]));
      saveArrowState();
      updateArrowGeometry();
      scheduleRender();
      window.SmoofDesignRenderer?.scheduleRender?.();
      return arrowState[side].rotation;
    },
    setCount(side, value) {
      if (side !== 'left' && side !== 'right') return false;
      const oldMetrics = arrowVisualMetrics(side, arrowState[side]);
      const centerX = arrowState[side].x + oldMetrics.offsetX + oldMetrics.width / 2;
      const centerY = arrowState[side].y + pictogramVisualHeight(
        arrowState[side],
        pictogramIsStandard(arrowState[side]) && arrowState[side].labelVisible
      ) / 2;
      arrowState[side].count = clamp(Math.round(Number(value) || 1), 1, 4);
      arrowState[side].scale = Math.min(
        pictogramScale(arrowState[side]),
        maximumPictogramScale(side, arrowState[side])
      );
      const newMetrics = arrowVisualMetrics(side, arrowState[side]);
      const newHeight = pictogramVisualHeight(
        arrowState[side],
        pictogramIsStandard(arrowState[side]) && arrowState[side].labelVisible
      );
      arrowState[side].x = centerX - newMetrics.offsetX - newMetrics.width / 2;
      arrowState[side].y = centerY - newHeight / 2;
      Object.assign(arrowState[side], constrainArrowPosition(side, arrowState[side]));
      saveArrowState();
      updateArrowGeometry();
      scheduleRender();
      window.SmoofDesignRenderer?.scheduleRender?.();
      return arrowState[side].count;
    },
    setSymbol(side, value) {
      if (side !== 'left' && side !== 'right') return false;
      const symbol = String(value || 'dots');
      if (!window.SmoofPictogramLibrary?.has?.(symbol)) return false;

      const oldMetrics = arrowVisualMetrics(side, arrowState[side]);
      const oldCenterX = arrowState[side].x + oldMetrics.offsetX + oldMetrics.width / 2;
      const oldHeight = pictogramVisualHeight(
        arrowState[side],
        arrowState[side].labelVisible
      );
      const oldCenterY = arrowState[side].y + oldHeight / 2;

      arrowState[side].symbol = symbol;
      if (!symbol.startsWith('custom-')) {
        arrowState[side].customSvg = '';
        arrowState[side].customName = '';
        arrowState[side].colorize = false;
      }
      arrowState[side].scale = Math.min(
        pictogramScale(arrowState[side]),
        maximumPictogramScale(side, arrowState[side])
      );
      const newMetrics = arrowVisualMetrics(side, arrowState[side]);
      const newHeight = pictogramVisualHeight(
        arrowState[side],
        arrowState[side].labelVisible
      );
      arrowState[side].x = oldCenterX - newMetrics.offsetX - newMetrics.width / 2;
      arrowState[side].y = oldCenterY - newHeight / 2;
      Object.assign(arrowState[side], constrainArrowPosition(side, arrowState[side]));
      saveArrowState();
      updateArrowGeometry();
      scheduleRender();
      window.SmoofDesignRenderer?.scheduleRender?.();
      return symbol;
    },
    setCustomSymbol(side, source, name = '') {
      if (side !== 'left' && side !== 'right') return false;
      const icon = window.SmoofPictogramLibrary?.registerCustom?.(source, name);
      if (!icon) return false;
      arrowState[side].customSvg = icon.source;
      arrowState[side].customName = name || icon.de;
      arrowState[side].colorize = false;
      return this.setSymbol(side, icon.id);
    },
    setCustomRaster(side, dataUrl, name = '', width = 100, height = 100) {
      if (side !== 'left' && side !== 'right') return false;
      const icon = window.SmoofPictogramLibrary?.registerRaster?.(
        dataUrl,
        name,
        width,
        height
      );
      if (!icon) return false;
      arrowState[side].customSvg = icon.source;
      arrowState[side].customName = name || icon.de;
      arrowState[side].colorize = false;
      return this.setSymbol(side, icon.id);
    },
    setColorize(side, value) {
      if (side !== 'left' && side !== 'right') return null;
      const icon = window.SmoofPictogramLibrary?.get?.(arrowState[side].symbol);
      if (icon?.raster !== true) return null;
      arrowState[side].colorize = Boolean(value);
      saveArrowState();
      updateArrowGeometry();
      scheduleRender();
      window.SmoofDesignRenderer?.scheduleRender?.();
      return arrowState[side].colorize;
    },
    setScale(side, value) {
      if (side !== 'left' && side !== 'right') return false;
      const current = arrowState[side];
      const oldMetrics = arrowVisualMetrics(side, current);
      const oldHeight = pictogramVisualHeight(
        current,
        pictogramIsStandard(current) && current.labelVisible
      );
      const centerX = current.x + oldMetrics.offsetX + oldMetrics.width / 2;
      const centerY = current.y + oldHeight / 2;
      current.scale = clamp(
        Number(value) || 1,
        0.1,
        maximumPictogramScale(side, current)
      );
      const newMetrics = arrowVisualMetrics(side, current);
      const newHeight = pictogramVisualHeight(
        current,
        pictogramIsStandard(current) && current.labelVisible
      );
      current.x = centerX - newMetrics.offsetX - newMetrics.width / 2;
      current.y = centerY - newHeight / 2;
      Object.assign(current, constrainArrowPosition(side, current));
      saveArrowState();
      updateArrowGeometry();
      scheduleRender();
      window.SmoofDesignRenderer?.scheduleRender?.();
      return current.scale;
    },
    setLabel(side, patch) {
      if(!['left','right'].includes(side)||!patch||typeof patch!=='object')return false;
      const state=arrowState[side],current=window.SmoofArrowLabels.resolve(state,side);
      state.label=window.SmoofArrowLabels.normalize({...current,...patch,legacy:false});
      saveArrowState();updateArrowGeometry();scheduleRender();window.SmoofDesignRenderer?.scheduleRender?.();
      return true;
    },
    toggleLabel(side) {
      if (side !== 'left' && side !== 'right') return false;
      syncLabels();
      arrowState[side].label={...arrowState[side].label,visible:!arrowState[side].labelVisible};
      syncLabels();
      arrowState[side].scale = Math.min(
        pictogramScale(arrowState[side]),
        maximumPictogramScale(side, arrowState[side])
      );
      Object.assign(arrowState[side], constrainArrowPosition(side, arrowState[side]));
      saveArrowState();
      updateArrowGeometry();
      scheduleRender();
      window.SmoofDesignRenderer?.scheduleRender?.();
      return arrowState[side].labelVisible;
    },
    getState(side = activeArrowSide) {
      syncLabels();
      return JSON.parse(JSON.stringify(arrowState[side]));
    },
    getHistoryState() {
      syncLabels();
      return {
        left: JSON.parse(JSON.stringify(arrowState.left)),
        right: JSON.parse(JSON.stringify(arrowState.right))
      };
    },
    applyHistoryState(next) {
      if (!next?.left || !next?.right) return false;
      arrowState.left = { ...ARROW_DEFAULTS.left, ...next.left };
      arrowState.right = { ...ARROW_DEFAULTS.right, ...next.right };
      for (const side of ['left','right']) arrowState[side].label=window.SmoofArrowLabels.migrate(next[side],side);
      syncLabels();
      ['left', 'right'].forEach(side => {
        if (arrowState[side].customSvg) {
          const icon = window.SmoofPictogramLibrary?.registerCustom?.(
            arrowState[side].customSvg,
            arrowState[side].customName || ''
          );
          if (icon) arrowState[side].symbol = icon.id;
        }
        if (!window.SmoofPictogramLibrary?.has?.(arrowState[side].symbol)) {
          arrowState[side].symbol = 'dots';
        }
        arrowState[side].scale = Math.min(
          pictogramScale(arrowState[side]),
          maximumPictogramScale(side, arrowState[side])
        );
        Object.assign(arrowState[side], constrainArrowPosition(side, arrowState[side]));
      });
      saveArrowState();
      updateArrowGeometry();
      scheduleRender();
      window.SmoofDesignRenderer?.scheduleRender?.();
      return true;
    }
  };

  window.addEventListener(
    EDITOR_SELECTION_EVENT,
    event => {
      applyArrowSelection(
        event.detail?.id
      );
    }
  );

  /*
   * Das rechte Kontextpanel liegt über einem Teil der Editorfläche.
   * Window-Capture hält einen begonnenen Drag auch dann aktiv, wenn der
   * Zeiger vom Piktogramm auf dieses Panel wechselt.
   */
  window.addEventListener('pointermove', moveArrowDrag, true);
  window.addEventListener('pointerup', finishArrowDrag, true);
  window.addEventListener('pointercancel', finishArrowDrag, true);
  window.addEventListener('blur', () => {
    if (!activeArrowDrag) return;
    activeArrowDrag = null;
    setArrowGuides();
    document.documentElement.removeAttribute('data-smoof-ui-dragging');
  });

  window.addEventListener(
    VARIANT_CHANGE_EVENT,
    scheduleRender
  );

  window.addEventListener(
    'smoof:qr-geometry-change',
    scheduleRender
  );

  window.addEventListener('smoof:pictogram-library-change', () => {
    updateArrowGeometry();
    scheduleRender();
    window.SmoofDesignRenderer?.scheduleRender?.();
  });

  ['smoof:editor-reset-all', 'smoof:editor-reset-content'].forEach(eventName => {
    window.addEventListener(eventName, () => {
      arrowState.left = { ...ARROW_DEFAULTS.left };
      arrowState.right = { ...ARROW_DEFAULTS.right };
      saveArrowState();
      updateArrowGeometry();
      scheduleRender();
      window.SmoofDesignRenderer?.scheduleRender?.();
    });
  });

  window.addEventListener('smoof:editor-reset-layout', () => {
    ['left', 'right'].forEach(side => {
      const defaults = ARROW_DEFAULTS[side];
      Object.assign(arrowState[side], {
        x: defaults.x,
        y: defaults.y,
        rotation: defaults.rotation,
        scale: defaults.scale
      });
    });
    saveArrowState();
    updateArrowGeometry();
    scheduleRender();
    window.SmoofDesignRenderer?.scheduleRender?.();
  });

  document.addEventListener(
    'input',
    scheduleRender,
    true
  );

  document.addEventListener(
    'change',
    scheduleRender,
    true
  );

  new MutationObserver(scheduleRender)
    .observe(document.body, {
      childList: true,
      subtree: true
    });

  window.setInterval(
    scheduleRender,
    500
  );

  scheduleRender();
})();
